import { classes } from "../../nucleo/classes";

type EstadoDaEtapa = "concluida" | "atual" | "adiante";

interface EtapaDoTrilho {
  numero: number;
  nome: string;
  estado: EstadoDaEtapa;
}

const ETAPAS: readonly EtapaDoTrilho[] = [
  { numero: 1, nome: "Contrato e cadastro", estado: "concluida" },
  { numero: 2, nome: "Infraestrutura", estado: "concluida" },
  { numero: 3, nome: "Kickoff dos módulos", estado: "atual" },
  { numero: 4, nome: "Reunião de kickoff", estado: "adiante" },
  { numero: 5, nome: "Execução e virada", estado: "adiante" },
];

const ROTULO: Record<EstadoDaEtapa, string> = {
  concluida: "concluída",
  atual: "em andamento",
  adiante: "a fazer",
};

/**
 * A esteira desenhada, do jeito que ela aparece dentro do portal.
 *
 * É ilustração, e a legenda diz isso — não há nome de empresa, data nem número aqui, para
 * não haver como confundir o desenho com o andamento de uma implantação real.
 */
export function TrilhoDaEsteira() {
  return (
    <figure className="trilho" aria-labelledby="trilho-legenda">
      <ol className="trilho__lista">
        {ETAPAS.map((etapa) => (
          <li
            key={etapa.numero}
            className={classes("trilho__etapa", `trilho__etapa--${etapa.estado}`)}
          >
            <span className="trilho__marca" aria-hidden="true">
              {etapa.estado === "concluida" ? "✓" : etapa.numero}
            </span>
            <span className="trilho__nome">{etapa.nome}</span>
            <span className="trilho__estado">{ROTULO[etapa.estado]}</span>
          </li>
        ))}
      </ol>
      <figcaption id="trilho-legenda" className="trilho__legenda">
        Exemplo de como a esteira aparece: cada etapa com o seu estado, sem depender de
        alguém perguntar por e-mail em que pé está.
      </figcaption>
    </figure>
  );
}
